<div class="booking-card shadow-sm">
  <div class="calendar-section__container">
    <div class="calendar__actions">
      <div *ngIf="staffMembers && staffMembers.length > 0" class="booking-staff">
        <label>Utövare</label>
        <mat-form-field appearance="outline">
          <mat-select
            #staffSelect
            (selectionChange)="handleStuffChange($event)"
            [(value)]="selectedStaffMemberId"
            class="test-booking-stuff-select">
            <mat-option
              *ngFor="
                let item of staffMembers;
                let i = index;
                trackBy: trackByMethod
              "
              [ngClass]="'test-booking-staff-' + i"
              [value]="item.id"
            >{{ item.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="calendar__calendar__container">
      <app-no-slots-available-no-match></app-no-slots-available-no-match>
      <app-week-picker-v2></app-week-picker-v2>
      <app-no-slots-available-redirected></app-no-slots-available-redirected>
      <app-date-picker-v2></app-date-picker-v2>
      <app-no-slots-available-doctor
        (allStuff)="handleStuffChange($event)"
        (staffSelectClick)="handleStaffSelectClick($event)"
      ></app-no-slots-available-doctor>
      <app-no-slots-available-at-all></app-no-slots-available-at-all>
      <app-no-slots-available-next-30-days></app-no-slots-available-next-30-days>
      <app-no-slots-available-next-90-days></app-no-slots-available-next-90-days>
      <app-no-slots-available-select-doctor
        (staffSelectClick)="handleStaffSelectClick($event)"
      ></app-no-slots-available-select-doctor>
    </div>
  </div>
</div>
